export default "/images/regel-1.jpg?c28fc4d012ff7a89ba79ef80a871d2b0";